export default __webpack_public_path__ + "static/media/walletBackground2.ed05d337.svg";